ACC.betatoggle = {

    bindOnChangeSwitchToggle: function () {
        $("#betaRedirectConfigured").change(function () {
            var betaRedirectConfigured = $(this).is(':checked');
            if (betaRedirectConfigured) {

                // Expiry date conversion into UTC standard string - 400 days
                var date = new Date();
                date.setDate(date.getDate() + 400);
                document.cookie = "beta-toggle" + "=" + "true" + "; path=/" + "; expires=" + date+ ";";
                location.reload();
            }
        });
    }
};

$(document).ready(function ()
{
    ACC.betatoggle.bindOnChangeSwitchToggle();
});
